/**
 * DO NOT MODIFY THIS FILE!
 * It was created by the Reefer icons generator.
 * For updates, please re-run the generator.
 */

import type { SVGProps } from 'react';

import type { IconComponentProps } from '../../icon/icon.types';
import { Icon } from '../icon';

const Government = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    className="Icon/Government"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#0E0E0E"
      fillRule="evenodd"
      d="M20.705 17.624c.715 0 1.295.588 1.295 1.313v1.75c0 .725-.58 1.313-1.296 1.313H4.296A1.304 1.304 0 0 1 3 20.687v-1.75c0-.725.58-1.313 1.295-1.313h.432v-7.001h-.432A1.304 1.304 0 0 1 3 9.31V7.092c0-.515.297-.982.76-1.195l8.204-3.78c.34-.156.732-.156 1.072 0l8.205 3.78c.462.213.759.68.759 1.195V9.31c0 .725-.58 1.313-1.296 1.313h-.431v7.001zm-12.523 0v-7.001H6.455v7.001zM4.727 20.25h15.546v-.876H4.727zm0-12.876v1.498h15.546V7.374L12.5 3.794zm6.91 10.25v-7.001H9.908v7.001zm3.454 0v-7.001h-1.727v7.001zm3.455 0v-7.001h-1.728v7.001z"
      className="SVG"
      clipRule="evenodd"
    />
  </svg>
);

export const GovernmentIcon = ({
  size = 'md',
  'data-testid': testId,
  ...props
}: IconComponentProps) => {
  return (
    <Icon
      data-testid={testId || 'government-icon'}
      icon={Government}
      {...props}
      size={size}
    />
  );
};
